import React, { useState } from "react";
import { Link } from "react-router-dom";
import faqIcon from "../../../assets/images/faq-icon.png";

const Faq = () => {
    const [faqList, setFaqList] = useState([
        {
            title: "What image formats are supported?",
            desc: `Our app supports popular formats including JPG, PNG, WebP, BMP, and GIF.`,
            show: true
        },
        {
            title: "Is the compression lossless or lossy?",
            desc: 'You can choose! The app supports both lossless (no quality loss) and lossy (smaller file size, slight quality trade-off) modes depending on your needs.'
        },
        {
            title: "Can I compress multiple images at once?",
            desc: 'Absolutely. Our app features batch compression, allowing you to compress entire folders with one click.'
        },
        {
            title: "Is an internet connection required?",
            desc: 'Yes. The app need Internet Connection to work, We keep your images secure and private and after 5 min from the compression time it will be auto deleted from server.'
        },
        {
            title: "Does it reduce image dimensions too?",
            desc: 'Yes, optionally. You can resize images while compressing to further reduce file size.'
        },
        {
            title: "Will it overwrite my original files?",
            desc: 'By default, the app saves compressed images to a new folder, but you can change the settings to overwrite originals if you prefer.'
        },
        {
            title: "Is it free to use?",
            desc: 'Yes! Our basic features are completely free, with optional upgrades for advanced users.'
        },
        {
            title: "What platforms are supported?",
            desc: 'Our app runs on Windows, macOS, and Linux.'
        }
    ])

    const faqToggle = (index) => {
        let newArr = []
        faqList.map((opt)=>{
            newArr.push({...opt, 'show': false})
        })
        newArr[index].show = !faqList[index].show
        setFaqList([...newArr])
    }
    return (
        <div className="faq-sctn">
            <div className="container">
                <div className="heading-left">
                    <h2>Frequently Asked Questions</h2>
                </div>
                <div className="row">
                    <div className="col-md-7">
                        <div className="panel-group">
                            {faqList.map((data, index) => {
                                return (
                                    <div className="panel panel-default" key={index.toString()}>
                                        <div className="panel-heading" role="tab" id="headingOne">
                                            <h4 className="panel-title mb-0">
                                                <a onClick={()=>faqToggle(index)} className={data.show ? "collapsed":""}>
                                                    {data.title}
                                                </a>
                                            </h4>
                                        </div>
                                        <div id="collapseOne" className={`panel-collapse collapse ${data.show ? "in":""}`} role="tabpanel" aria-labelledby="headingOne">
                                            <div className="panel-body">
                                                {data.desc}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            }
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className="faq-imghldr">
                            <img src={faqIcon} className="img-fluid" alt="" />
                        </div>
                        {/* <div className="header-btn">
                            <a href="https://wordpress.org/plugins/jpeg-png-compressor/" target="_blank" className="btn-cmn btn-grn ">DOWNLOAD NOW</a>

                            <Link to='/developer-api' className="btn-cmn btn-grn-outline get">GET API KEY</Link>
                        </div> */}
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        </div>
    )
}

export default Faq;